const walkForce = 6;
export default function MoveLeft(scene, level) {
  const {
    player
  } = level;
  function move(active) {
    player.velocity.x = active ? -walkForce : 0;
  }
  return move;
}